<template>
  <eden-master-search
    separator-text="Resultado de Informes"
    :page-config="pageConfig"
    :page-actions-config="headerActions"
    :academic-years="options.academicYears"
    :create-report-visible="createReportVisible"
    :report-available-academic-years="options.reportAvailableAcademicYears"
    :data="resultData"
    :pagination-page-size="pageSize"
    :selected-academic-year="filter.academicYear"
    :eden-report-type-id="edenTypesEnum.EXIT"
    @on-create-report="onOpenCreateReportHandler"
    @on-cancel-report="onCancelCreateReportHandler"
    @on-continue-create-report="onContinueCreateReportHandler"
    @on-search-result="getSearchResult(1)"
    @on-change-page="getSearchResult($event.pageIndex)"
    @on-enter="onEnterHandler($event)"
    @on-change-academic-year="onChangeAcademicYearHandler"
    @on-publish-data="onPublishDataHandler"
  />
</template>

<script>
import storeMixin from "utils/mixins/storeGenerator";
import EdenMasterSearch from "../shared/components/EdenMasterSearch.vue";
import Service from "@/services/api/edenexit.api";

//constants
import edenTypes from '@/utils/constants/edenTypes.js'
const STORE_MODULE_NAME = "edenExitModule";

export default {
  name: "EdenMain",
  components: {
    EdenMasterSearch,
  },
  mixins: [storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
    filter: {
      academicYear: null,
    },
    options: {
      academicYears: [],
      reportAvailableAcademicYears: [],
    },
    resultData: {
      result: [],
      pagination: {},
    },
    createReportVisible: null,
  }),
  computed: {
    pageSize() {
      return 10;
    },
    pageConfig() {
      return {
        title: "Egreso",
        icon: "fas fa-calculator",
        routes: ["Inicio", "618 Data", "Egreso"],
      };
    },
    headerActions() {
      return [
        {
          text: "Crear Reporte",
          icon: "fas fa-file-plus pr-2",
          variant: "success",
          visible: !this.createReportVisible,
          click: () => this.onOpenCreateReportHandler(),
        },
      ];
    },
    edenTypesEnum() {
      return edenTypes
    },
  },
  async mounted() {
    this.getInit();
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    async getInit() {
      await this.getAcademicYears();
      await this.getSearchResult();
    },
    async getAcademicYears() {
      var response = await Service.getAvailableAcademicYears();
      this.options.academicYears = response.data;
    },
    async getSearchResult(pageIndex = 1) {
      const payload = {
        AcademicYearId: this.filter.academicYear?.id,
        PageIndex: pageIndex,
        PageSize: this.pageSize,
      };
      var { data: response } = await Service.getExitByYear(payload);
      this.resultData = {
        result: response.data,
        pagination: {
          ...this.resultData.pagination,
          currentPage: response.currentPage,
          totalItemCount: response.totalItemCount,
          pageCount: response.pageCount,
          count: response.count,
          perPage: this.pageSize,
        },
      };
    },
    onEnterHandler(edenExitId) {
      this.$router.push({
        name: "edenExitDetails",
        params: {
          id: edenExitId,
        },
      });
    },
    onCancelCreateReportHandler() {
      this.createReportVisible = false;
    },
    async onOpenCreateReportHandler() {
      this.options.reportAvailableAcademicYears = (
        await Service.getReportAvailableAcademicYears()
      ).data;
      this.createReportVisible = true;
    },
    async onContinueCreateReportHandler(academicYearId) {
      if (academicYearId) {
        await Service.createEdenExitReport(academicYearId)
          .then(async ({ data }) => {
            if (data) {
              this.ShowToast(
                "Proceso Exitoso",
                "El reporte ha sido creado exitosamente.",
                "success"
              );
              this.onCancelCreateReportHandler();
              await this.getInit();
            }
          })
          .catch((err) => {
            this.ShowToast("", err.response?.data?.message, "error");
          });
      }
    },
    onChangeAcademicYearHandler(value) {
      this.filter.academicYear = value;
    },
    async onPublishDataHandler(item) {
      if (item?.id) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          '¿Está seguro(a) que desea publicar los datos al portal público de educación especial?',
          'Sí',
          'No'
        )
        if (!answer) return

        const { data } = await Service.publishPublicPortalData(item.id).catch(
          (err) => {
            this.ShowToast(
              'Alerta',
              err.response.data.message || 'error',
              'error'
            )
            return
          }
        )
        if (data) {
          this.ShowToast(
            'Proceso Exitoso',
            'Los datos han sido publicados exitosamente.',
            'success'
          )
        }
      }
    },
  },
};
</script>

<style lang="scss">
@media (max-width: 425px) {
  .mobile-separator {
    .separator-custom {
      font-size: 11px !important;
      font-weight: 100 !important;
    }
  }
  .button-mobile-custom {
    width: 95% !important;
  }
}
</style>
